import { myFetch, HttpMethod } from './baseService';

export interface ApiEnvelope<T> {
  code: string | number;
  message: string;
  object_: T;
}

export interface Vehiculo {
  veh_codigo: number;
  veh_torre?: string;
  veh_torre_nombre?: string;
  veh_apartamento?: string;
  veh_apartamento_nombre?: string;
  veh_tipo?: string;
  veh_tipo_nombre?: string;
  veh_marca?: string;
  veh_marca_nombre?: string;
  veh_numero_placa?: string;
  veh_nombre_ciudad?: string;
  veh_fecha_creacion?: string;
  veh_foto?: string;
  [key: string]: any;
}

export interface ObtenerVehiculosRequest {
  codigo: string;
  "unidad residencial codigo": string;
  "apartamento codigo": string;
  "numero placa": string;
}

export interface ObtenerVehiculoDetalleRequest {
  codigo: string;
  "unidad residencial codigo": string;
  "apartamento codigo": string;
  "numero placa": string;
}

export const obtenerVehiculos = async (payload: ObtenerVehiculosRequest) => {
  const requestPayload = {
    codigo: String(payload.codigo || ""),
    "unidad residencial codigo": String(payload["unidad residencial codigo"] || ""),
    "apartamento codigo": String(payload["apartamento codigo"] || ""),
    "numero placa": String(payload["numero placa"] || ""),
  };
  
  const envelope = await myFetch<ApiEnvelope<Vehiculo[]>>(
    'vehiculo/ObtenerTodos',
    HttpMethod.POST,
    requestPayload
  );
  return envelope;
};

export const obtenerVehiculoDetalle = async (payload: ObtenerVehiculoDetalleRequest) => {
  const requestPayload = {
    codigo: String(payload.codigo || ""),
    "unidad residencial codigo": String(payload["unidad residencial codigo"] || ""),
    "apartamento codigo": String(payload["apartamento codigo"] || ""),
    "numero placa": String(payload["numero placa"] || ""),
  };
  
  const envelope = await myFetch<ApiEnvelope<Vehiculo[]>>(
    'vehiculo/ObtenerTodos',
    HttpMethod.POST,
    requestPayload
  );
  return envelope;
};

